const NAME = "EXTRA_HOURS_AUTHORIZATION";

export default NAME;
